import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  postWithTokenAPI,
  putWithTokenAPI,
  getWithTokenAPI,
  patchWithTokenAPI,
  getWithoutTokenAPI,
} from "../../Util/Api";
import { FaSave, FaUndo, FaArrowLeft, FaTimes } from "react-icons/fa";
import "../../Style/Pages/Role.css";
import { useNavigate, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import Select from "react-select";
import { FaEye, FaEyeSlash } from "react-icons/fa";
// import { TableSkeleton } from "../Skeleton/Skeleton";
const ResourceCreate = () => {
  const auth = useSelector((state) => state.auth);
  const token = auth.token;
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditMode = !!id;
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    phoneNumber: "",
    date: "",
    role: "",
    roleType: "admin",
  });
  console.log(formData, "formData------------");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [roles, setRoles] = useState([]);
  const [fetchLoading, setFetchLoading] = useState(false);
  const roleOptions = roles?.map((role) => ({
    value: role._id,
    label: role.title,
  }));
  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const res = await getWithTokenAPI(token, "/role/list");
        const rolesList = res?.data?.roles || [];
        setRoles(rolesList);

        if (rolesList.length > 0 && !formData.role) {
          setFormData((prev) => ({
            ...prev,
            role: rolesList[0]._id,
          }));
        }
      } catch (error) {
        console.error("Error fetching roles", error);
      }
    };
    fetchRoles();
  }, [token]);

  useEffect(() => {
    const fetchUserDetails = async () => {
      if (!id) return;
      try {
        setFetchLoading(true);
        const res = await getWithoutTokenAPI(`/user/profile/${id}`);

        if (res.statusCode === 200) {
          const user = res.data;
          let roleId = user.role;
          if (user.role && typeof user.role === "object") {
            roleId = user.role._id;
          }

          setFormData({
            name: user.name || "",
            email: user.email || "",
            password: "",
            phoneNumber: user.phoneNumber || "",
            date: user.createdAt ? user.createdAt.split("T")[0] : "",
            role: user.roles_pemission || "",
            roleType: "admin",
          });
        }
      } catch (error) {
        console.error("Error fetching user details", error);
        toast.error("Failed to fetch user details");
      } finally {
        setFetchLoading(false);
      }
    };

    fetchUserDetails();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleReset = () => {
    setFormData({
      name: "",
      email: "",
      password: "",
      phoneNumber: "",
      date: "",
      role: roles.length > 0 ? roles[0]._id : "",
      roleType: "admin",
    });
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!formData.name.trim()) {
      setError("Name is required");
      return;
    }
    if (!formData.email.trim()) {
      setError("Email is required");
      return;
    }
    if (!isEditMode && !formData.password.trim()) {
      setError("Password is required for new resource");
      return;
    }
    if (!formData.phoneNumber.trim()) {
      setError("Phone number is required");
      return;
    }
    if (!formData.role) {
      setError("Role is required");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const submitData = {
        name: formData.name,
        email: formData.email,
        phoneNumber: formData.phoneNumber,
        roletype: "admin",
        countryCode: "+91",
        roles_pemission: formData.role,
        ...(!isEditMode && { password: formData.password }),
      };

      let response;

      if (isEditMode) {
        response = await putWithTokenAPI(
          token,
          `/user/update/${id}`,
          submitData,
        );
      } else {
        response = await postWithTokenAPI(token, "/user/create ", submitData);
      }

      if (response?.statusCode === 200 || response?.statusCode === 201) {
        toast.success(
          isEditMode
            ? "Resource updated successfully"
            : "Resource created successfully",
        );
        setTimeout(() => navigate("/admin/resource"), 1500);
      } else {
        setError(
          response?.data?.message ||
            `Failed to ${isEditMode ? "update" : "create"} resource`,
        );
        toast.error(
          response?.data?.message ||
            `Failed to ${isEditMode ? "update" : "create"} resource`,
        );
      }
    } catch (error) {
      setError(
        error?.response?.data?.message ||
          `Error ${isEditMode ? "updating" : "creating"} resource`,
      );
        toast.error(
          error?.response?.data?.message ||
            `Error ${isEditMode ? "updating" : "creating"} resource`,
        );
      console.error("Error saving resource", error);
    } finally {
      setLoading(false);
    }
  };

  if (fetchLoading) {
    return (
      <div className="role-create-container">
        <div className="loading-state">
          {/* <TableSkeleton columns={[]} color={"#8c1007"} /> */}
        </div>
      </div>
    );
  }

  return (
    <div className="role-create-container">
      <div className="role-create-header">
        <div className="header-with-back">
          <button
            type="button"
            className="back-button"
            onClick={() => navigate("/admin/resource")}
          >
            <FaArrowLeft size={20} />
          </button>
          <h2 className="role-create-title">
            {isEditMode ? "Edit Resource" : "Create Resource"}
          </h2>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="role-create-form">
        <div className="role-basic-info-section">
          {/* Name Field */}
          <div className="form-group">
            <label className="form-label">
              Name <span className="required">*</span>
            </label>
            <input
              type="text"
              name="name"
              className="form-input"
              placeholder="Enter full name"
              value={formData.name}
              onChange={handleChange}
            />
          </div>

          {/* Email Field */}
          <div className="form-group">
            <label className="form-label">
              Email <span className="required">*</span>
            </label>
            <input
              type="email"
              name="email"
              className="form-input"
              placeholder="Enter email address"
              value={formData.email}
              onChange={handleChange}
              disabled={isEditMode}
            />
            {isEditMode && (
              <small className="form-hint">Email cannot be changed</small>
            )}
          </div>

          {/* Password Field - Only for Create Mode */}
          {!isEditMode && (
            <div className="form-group">
              <label className="form-label">
                Password <span className="required">*</span>
              </label>

              <div className="password-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  className="form-input"
                  placeholder="Enter password"
                  value={formData.password}
                  onChange={handleChange}
                />

                <span
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
            </div>
          )}

          {/* Phone Number Field */}
          <div className="form-group">
            <label className="form-label">
              Phone Number <span className="required">*</span>
            </label>
            <input
              type="tel"
              name="phoneNumber"
              className="form-input"
              placeholder="Enter phone number"
              value={formData.phoneNumber}
              onChange={handleChange}
              maxLength={10}
              // disabled={isEditMode}
            />
          </div>

          {/* Role Dropdown - Shows Title, Sets _id */}
          <div className="form-group">
            <label className="form-label">
              Role <span className="required">*</span>
            </label>

            <Select
              name="role"
              options={roleOptions}
              value={roleOptions.find(
                (option) => option.value === formData.role,
              )}
              onChange={(selectedOption) =>
                setFormData({ ...formData, role: selectedOption.value })
              }
              placeholder="Select a role"
            />
          </div>
        </div>

        {/* Error Message */}
        {error && (
          <div className="error-message">
            <FaTimes className="message-icon" />
            {error}
          </div>
        )}

        {/* Form Actions */}
        <div className="form-actions">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleReset}
            disabled={loading}
          >
            <FaUndo className="btn-icon" />
            Cancel
          </button>
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? (
              <>
                <span className="loading-spinner-small"></span>
                {isEditMode ? "Updating..." : "Creating..."}
              </>
            ) : (
              <>
                <FaSave className="btn-icon" />
                {isEditMode ? "Update" : "Create"}
              </>
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ResourceCreate;
